import React from 'react'
import cx from 'classnames'
import { Text } from '@components/UI'

export const Tabs = ({ activeTab, setActiveTab, tabs, children }) => {
  return (
    <div className='gp-tabs'>
      <div className='gp-tabs-header'>
        {tabs.map((tab) => (
          <div
            className={cx({
              'gp-tabs-headerTab': true,
              active: tab.id === activeTab
            })}
            onClick={() => setActiveTab(tab.id)}
            key={tab.id}
          >
            <Text>{tab.title}</Text>
          </div>
        ))}
      </div>

      {children}
    </div>
  )
}
